import React, { useEffect, useState } from 'react';
import { pageTitle } from '../../helper';
import { formatTableDate, paymentApiUrl, readJsonResponse } from '../../utils/payment';
import Div from '../Div';
import PageHeading from '../PageHeading';
import Spacing from '../Spacing';

export default function AdminReconciliationPage() {
  const [rows, setRows] = useState([]);
  const [error, setError] = useState('');

  useEffect(() => {
    pageTitle('Reconciliation');
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    fetch(paymentApiUrl('/api/admin/reconciliation'))
      .then(readJsonResponse)
      .then((data) => setRows(data.rows || []))
      .catch((fetchError) => setError(fetchError.message));
  }, []);

  return (
    <>
      <PageHeading title="Finance Reconciliation" bgSrc="/images/service_hero_bg.jpeg" pageLinkText="Reconciliation" />
      <Spacing lg="120" md="70" />
      <Div className="container">
        {error ? <p className="cs-m0" style={{ color: '#ff6b6b' }}>{error}</p> : null}
        <Div style={{ overflowX: 'auto' }}>
          <table className="table" style={{ width: '100%', minWidth: 980 }}>
            <thead>
              <tr>
                <th>Date</th>
                <th>Ref No</th>
                <th>Gateway ID</th>
                <th>Customer</th>
                <th>Amount</th>
                <th>Currency</th>
                <th>Status</th>
                <th>Settlement</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((row) => (
                <tr key={row.referenceNumber}>
                  <td>{formatTableDate(row.date)}</td>
                  <td>{row.referenceNumber}</td>
                  <td>{row.gatewayId || '-'}</td>
                  <td>{row.customerFullName}</td>
                  <td>{Number(row.amount).toFixed(2)}</td>
                  <td>{row.currency}</td>
                  <td>{row.status}</td>
                  <td>{row.settlement}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </Div>
      </Div>
      <Spacing lg="120" md="70" />
    </>
  );
}
